import { render, staticRenderFns } from "./ActivityWsConfirmationImage.vue?vue&type=template&id=aded000e&scoped=true"
import script from "./ActivityWsConfirmationImage.vue?vue&type=script&lang=ts"
export * from "./ActivityWsConfirmationImage.vue?vue&type=script&lang=ts"
import style0 from "./ActivityWsConfirmationImage.vue?vue&type=style&index=0&id=aded000e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aded000e",
  null
  
)

export default component.exports